import styles from "./CreateCommunityPage.module.css";

const getFileNameFromUrl = (url) => {
  if (!url) return "";

  try {
    // Remove query params if any
    const cleanUrl = url.split("?")[0];

    // Get last part after /
    return decodeURIComponent(cleanUrl.split("/").pop());
  } catch (e) {
    return "";
  }
};

const AttachmentLink = ({ fileUrl, video, onClick }) => {
  if (!fileUrl) return null;

  const handleClick = (e) => {
    e.stopPropagation();
    onClick?.(e, fileUrl, video);
  };

  return (
    <span
      className={styles.attachmentLink}
      onClick={handleClick}
      title="Open attachment"
    >
      📎 {getFileNameFromUrl(fileUrl)}
    </span>
  );
};

export default AttachmentLink;
